
import { Component, Vue, Prop } from 'vue-property-decorator'
import { EnterpriseService } from '@/services/index'

@Component({
    name: 'company-table'
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]
    private statusOptions = [
        { key: 1, value: '已审核' },
        { key: 2, value: '未审核' },
        { key: 3, value: '不通过' }
    ]

    private async updateStatus(params: any) {
        const result = await EnterpriseService.updateCompanyInfo(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        }
        return {
            status: false,
            message: result.message
        }
    }

    private async onStatusSelect(status: any, item: any) {
        this.$set(item, 'loading', true)
        const { id: companyId } = item
        const params = { id: companyId, check: status }
        const result = await this.updateStatus(params)
        item.loading = false
        if (result.status) {
            item.check = status
        }
    }

    private async onHistoryChange(bol: any, item: any) {
        this.$set(item, 'loading', true)
        const { id: companyId } = item
        const params = { id: companyId, history_status: bol }
        const result = await EnterpriseService.updateCompanyInfo(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            item.history_status = bol
        } else {
            this.$message({ type: 'error', message: result.message })
        }
        item.loading = false
    }
}
